import React, { useEffect, useState } from "react";

const languages = [
    { code: "en", name: "English", flag: "/assets/images/flags/us.jpg" },
    { code: "es", name: "Spanish", flag: "/assets/images/flags/spain.jpg" },
    // { code: "gr", name: "German", flag: "/assets/images/flags/germany.jpg" },
    { code: "it", name: "Italian", flag: "/assets/images/flags/italy.jpg" },
    { code: "ru", name: "Russian", flag: "/assets/images/flags/russia.jpg" },
    // { code: "hi", name: "Hindi", flag: "/assets/images/flags/india.jpg" },
    // { code: "gu", name: "Gujarati", flag: "/assets/images/flags/india.jpg" },
];

const LanguageSelector = () => {
    const [selectedLang, setSelectedLang] = useState(
        localStorage.getItem("selectedLanguage") || "en"
    );

    const changeLanguage = (lang) => {
        const googleSelect = document.querySelector(".goog-te-combo");
        if (googleSelect) {
            googleSelect.value = lang;
            googleSelect.dispatchEvent(new Event("change"));
            localStorage.setItem("selectedLanguage", lang);
            setSelectedLang(lang);

            window.dispatchEvent(new Event("languageChanged"));

        } else {
            console.warn("Google Translate not ready yet!");
        }
    };

    const initGoogleTranslate = () => {
        if (!window.google || !window.google.translate) return;

        new window.google.translate.TranslateElement(
            { pageLanguage: "en" },
            "google_translate_element"
        );

        const savedLang = localStorage.getItem("selectedLanguage") || "en";
        setTimeout(() => {
            const googleSelect = document.querySelector(".goog-te-combo");
            if (googleSelect) {
                googleSelect.value = savedLang;
                googleSelect.dispatchEvent(new Event("change"));
            }
        }, 1200);
    };

    useEffect(() => {
        const googleSelect = document.querySelector(".goog-te-combo");
        if (googleSelect) {
            googleSelect.value = selectedLang;
            googleSelect.dispatchEvent(new Event("change"));
        }
    }, [selectedLang]);

    useEffect(() => {
        const handler = () => {
            setSelectedLang(localStorage.getItem("selectedLanguage") || "en");
        };

        window.addEventListener("storage", handler);

        return () => {
            window.removeEventListener("storage", handler);
        };
    }, []);

    useEffect(() => {

        if (!document.querySelector("#google-translate-script")) {
            const script = document.createElement("script");
            script.id = "google-translate-script";
            script.src =
                "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
            document.body.appendChild(script);
        }

        window.googleTranslateElementInit = initGoogleTranslate;
    }, []);

    // useEffect(() => {
    //     setTimeout(() => {
    //         initGoogleTranslate();
    //     }, 500);
    // }, [location.pathname]);

    return (
        <>
            {languages.map((lang) => (
                <button
                    key={lang.code}
                    className={`dropdown-item notify-item language notranslate ${selectedLang === lang.code ? "active" : ""
                        }`}
                    onClick={() => changeLanguage(lang.code)}
                >
                    <img src={lang.flag} alt={lang.name} className="me-1" height={12} />
                    <span className="align-middle notranslate">{lang.name}</span>
                </button>

            ))}

            {/* <div id="google_translate_element" style={{ display: "none" }}></div> */}
        </>
    );
};

export default LanguageSelector;